export const GROUP_BY_NONE = "none";
export const GROUP_BY_STATISTIC = "statistic";
export const GROUP_BY_TEAM = "team";
export const GROUP_BY_PLAYER = "player";
